<template>
	<v-container fluid grid-list-md pa-0 px-2 mb-4>
		<v-layout row wrap>
			<v-flex>
				<date-picker
					label="Data inizio"
					v-model="dStartDate"
					:max="dEndDate"
					@input="dTimeIntervalSelected = 'custom'"
				/>
			</v-flex>

			<v-flex>
				<date-picker
					label="Data fine"
					v-model="dEndDate"
					:min="dStartDate"
					:max="dMaxEndInterval"
					@input="dTimeIntervalSelected = 'custom'"
				/>
			</v-flex>

			<v-spacer></v-spacer>

			<v-flex>
				<v-btn
					color="primary"
					@click="$emit('click')"
				>
					<v-icon left>fas fa-sync-alt</v-icon>
					Aggiorna dati
				</v-btn>
			</v-flex>
			</v-layout>
			
			<v-layout row wrap>

			<v-flex xs12>
				<v-toolbar-items>
					<v-btn-toggle
						mandatory
						v-model="dTimeIntervalSelected"
						@change="setInterval(dTimeIntervalSelected)"
					>
						<v-btn class="toggle-btn" text value="today">
							<v-icon left :size="20">fa-calendar-day</v-icon>
							Oggi
						</v-btn>
						<v-btn class="toggle-btn" text value="week">
							<v-icon left :size="20">fa-calendar-week</v-icon>
							Settimana
						</v-btn>
						<v-btn class="toggle-btn" text value="month">
							<v-icon left :size="20">fa-calendar-alt</v-icon>
							Mese
						</v-btn>
						<v-btn class="toggle-btn" text value="year">
							<v-icon left :size="20">fa-calendar</v-icon>
							Anno
						</v-btn>
						<v-btn class="toggle-btn" text value="ever">
							<v-icon left :size="20">fa-infinity</v-icon>
							Sempre
						</v-btn>
						<v-btn class="toggle-btn" text value="custom">
							<v-icon left :size="20">far fa-calendar</v-icon>
							Personalizzato
						</v-btn>
					</v-btn-toggle>
				</v-toolbar-items>
			</v-flex>
		</v-layout>
	</v-container>
</template>


<script>
	import DatePicker from "@components/forms/DatePicker.vue";

	import * as moment from 'moment';
	import 'moment/locale/it';

	var today = moment();

	export default {
		props: {
			value: {
				type: Array,
				default: () => []
			},

			defaultInterval: {
				type: String,
				default: "week"
			},

			refresh: {
				type: Boolean,
				default: false
			},

			refreshRate: {
				type: Number,
				default: 30
			}
		},

		components: {
			DatePicker
		},

		data() {
			return {
				dStartDate: null,
				dEndDate: null,
				dTimeIntervalSelected: null,
				dRefreshRate: 10,		// Seconds after which the data will be refreshed
				hRefreshTimer: null,	// Hidden variable to handle the refresh timer
				dMaxStartInterval: today.format("YYYY-MM-DD"),
				dMaxEndInterval: today.format("YYYY-MM-DD")
			}
		},

		methods: {
			/**
			 * Sets the research interval according to the time span passed as
			 * argument. This parameter is related to the toolbar button choosed.
			 *
			 * @param      {int}  timespan  The timespan type to apply, according to the button pressed.
			 */
			setInterval(timespan) {
				// All the preset intervals span from today back to a specified
				// amount of days in the past.
				let endInterval = moment();
				let startInterval = undefined;
				
				switch(timespan) {
					case "today":
						startInterval = endInterval;
						break;
					
					case "week":
						startInterval = moment().startOf("week");
						break
					
					case "month":
						startInterval = moment().startOf("month");
						break;

					case "year":
						startInterval = moment().startOf("year");
						break;

					case "ever":
						startInterval = moment("1970-01-01");
						break;

					case "custom":
						break;

					default:
						startInterval = endInterval;
				}

				this.dStartDate = startInterval.format("YYYY-MM-DD");
				this.dEndDate = endInterval.format("YYYY-MM-DD");

				this.$emit("input", [this.dStartDate, this.dEndDate]);
				this.$emit("click");
			},

			/**
			 * Set a refresh rate of the validation data.
			 * @param seconds Number of seconds after which the data will be refetched.
			 * Zero or negative values disables the refresh rate.
			 */
			setRefreshRate(seconds) {
				this.dRefreshRate = seconds;
				if(seconds <= 0) {
					this.disableRefresh();
					return;
				}
				this.hRefreshTimer = setInterval(() => { this.$emit('click'); }, seconds * 1000);
			},

			disableRefresh() {
				clearInterval(this.hRefreshTimer);
				this.hRefreshTimer = null;
			}
		},

		created() {
			this.dTimeIntervalSelected = this.defaultInterval;
			this.setInterval(this.defaultInterval);

			if(this.refresh) {
				this.setRefreshRate(this.refreshRate)
			}
		},

		beforeDestroy() {
			this.disableRefresh();
		}
	}
</script>

<style>
	.toggle-btn {
		min-width: 100px;
	}
</style>